'use strict';

const social = {
    init: function () {
        let main = document.querySelector('.sticky_social');
        let btn = document.querySelector('.sticky_social-toggle');
        if(btn) {
            btn.addEventListener('click', function() {
                main.classList.contains('opened') ? main.classList.remove('opened') : main.classList.add('opened');
            });
        }
    },
};

export default social;


// WEBPACK FOOTER //
// ./src/scripts/components/social.js